export const menuItems = [
    {
        name: 'jobList',
        route: '/jobs',
        matchingRoutes: ['/jobs'],
    },
    {
        name: 'jobseekerList',
        route: '/jobseekers',
        matchingRoutes: ['/jobseekers'],
    },
    {
        name: 'companyList',
        route: '/companies',
        matchingRoutes: ['/companies'],
    },
    {
        name: 'blog',
        route: '/blog',
        matchingRoutes: ['/blog'],
    },
    {
        name: 'about',
        route: '/about',
        matchingRoutes: ['/about'],
    },
];
